import React, { useEffect, useState } from 'react';
import { getAdobeDataLayer, O2PopupMessage, O2PopupMessageItem } from 'o2-theme-react';
import { format } from 'date-fns';
import axios from 'axios';
import { connect, useSelector } from 'react-redux';
import { newId } from './utils/idGenerator';
import { RESOURCE_APPLICATION } from '../../../resourceUtils';
import { KahlInfo } from '../../../redux/reducers/types';
import StoreState from '../../../redux/store/storeState';
import { I18n } from 'react-i18nify-lite';

interface IKahlMessage {
  id: string;
  text: string;
  color: string | '"internal" | "success" | "warning" | "danger" | undefined';
  autoClose: number;
  closeBtn: boolean;
}

interface StateProps {
  kahlInfo: KahlInfo;
}

interface Props extends StateProps {}

const KahlMessages: React.FC<Props> = ({ kahlInfo }) => {
  const { setMessage } = getAdobeDataLayer();
  const [messages, setMessages] = useState([]);
  const [ locale, setLocale ] = useState<string>('cs');
  const sharedObjectSession = useSelector<any, any>(
    state => state.sharedObjectSession
  );

  useEffect(() => {
    if (sharedObjectSession) {
      if (sharedObjectSession.sharedObjectSession.generalLoginData.userPreferences.locale) {
        setLocale(sharedObjectSession.sharedObjectSession.generalLoginData.userPreferences.locale);
      }
    }
  }, [ sharedObjectSession ])

  useEffect(() => {
    if (kahlInfo.kahlMessageId !== null) {
      handleKahlMessage(kahlInfo);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kahlInfo]);

  const handleKahlMessage = (
    kahlInfo: KahlInfo
  ) => {
    console.log('TEST');
    console.log({
      messageId: '999999',
      messageType: 'error',
      messageDescription: 'TEST'
    });
    
    setMessage({
      messageId: '999999',
      messageType: 'error',
      messageDescription: 'TEST'
    });
    
    const url = (window as any).g_apfApiLocation + '/api/kahl/public/v1/kahl';
    const timestamp = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");
    const sourceApp = RESOURCE_APPLICATION;

    const kahlUrl = `${url}?infoMessageIds=${kahlInfo.kahlMessageId}&timestamp=${timestamp}&sourceApplication=${sourceApp}&locale=${locale}`;

    axios
      .get(kahlUrl, { withCredentials: true })
      .then(res => {
        for (let i = 0; i < res.data.length; i++) {
          let kahlMessageData = res.data[i];

          let kahlMessage = {
            id: newId(),
            text: kahlMessageData.text,
            color: getKahlColor(
              kahlMessageData.errorType,
              kahlMessageData.isInternal
            ),
            autoClose: kahlMessageData.errorType === 1 ? 10 : 5,
            closeBtn: kahlMessageData.errorType <= 3,
          };
          console.log('ADOBE ANALYTICS | setMessage:');
          console.log({
            messageId: String(kahlInfo.kahlMessageId),
            messageType: getKahlSeverityText(
              kahlMessageData.errorType,
              kahlMessageData.isInternal
              ),
            messageDescription: kahlMessageData.text
          });
          
          setMessage({
            messageId: String(kahlInfo.kahlMessageId),
            messageType: getKahlSeverityText(
              kahlMessageData.errorType,
              kahlMessageData.isInternal
              ),
            messageDescription: kahlMessageData.text
          });

          addKahlMessage(kahlMessage);
        }
      })
      .catch(err => {
        let kahlMessage;
        if (kahlInfo.kahlMessageDefaultType === 'success') {
          kahlMessage = {
            id: newId(),
            text: I18n.t('ume.ext.kahl.default.success'),
            color: 'success',
            autoClose: 10,
            closeBtn: true,
          };
        } else {
          kahlMessage = {
            id: newId(),
            text: I18n.t('ume.ext.kahl.default.danger'),
            color: 'danger',
            autoClose: 10,
            closeBtn: true,
          };
        }

        addKahlMessage(kahlMessage);
      });
  };

  const addKahlMessage = (kahlMessage: IKahlMessage) => {
    if (kahlMessage.autoClose !== 0) {
      setTimeout(() => {
        handleClose(kahlMessage.id);
      }, kahlMessage.autoClose * 1000);
    }

    setMessages(messages => {
      let kahlMessages: any = [...messages];
      kahlMessages.push(kahlMessage);
      return kahlMessages;
    });
  };

  const getKahlColor = (severity: string, isInternal: boolean) => {
    if (isInternal) {
      return 'internal';
    } else {
      if (severity === '2' || severity === '3') {
        return 'success';
      } else if (severity === '3') {
        return 'warning';
      } else {
        return 'danger';
      }
    }
  };

  const getKahlSeverityText = (severity: string, isInternal: boolean) => {
    if (isInternal) {
      return 'warning';
    } else {
      if (severity === '2' || severity === '3') {
        return 'success';
      } else if (severity === '3') {
        return 'warning';
      } else {
        return 'error';
      }
    }
  };

  const handleClose = (id: string) => {
    setMessages(messages => [
      ...messages.filter((message: IKahlMessage) => message.id !== id),
    ]);
  };
  return (
    <O2PopupMessage>
      {messages &&
        messages.map((message: any) => (
          <O2PopupMessageItem
            key={message.id}
            color={message.color}
            onClose={() => handleClose(message.id)}
            closeBtn={message.closeBtn}
          >
            <div dangerouslySetInnerHTML={{ __html: message.text }} />
          </O2PopupMessageItem>
        ))}
    </O2PopupMessage>
  );
};

const mapStateToProps = (state: StoreState): StateProps => ({
  kahlInfo: state.kahlInfo
});

export default connect(mapStateToProps, null)(KahlMessages);
